export function getView(is_location_changing) {
  return is_location_changing ? 'Loading' : 'Content'
}
